var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c("div", { staticClass: "overlay" }, [
    _c("div", { staticClass: "overlay__wrapper" }, [
      _c("div", { staticClass: "overlay__content" }, [
        _c(
          "ul",
          {
            staticClass: "modal__content-list modal__content-list--edit",
            attrs: { id: "modal-content" }
          },
          [
            _c(
              "li",
              { staticClass: "modal__content-item modal__content-item--title" },
              [
                _c("span", { staticClass: "modal__title" }, [
                  _c("span", { staticClass: "modal__title--limited" }, [
                    _vm._v(" „" + _vm._s(_vm.job.name) + "“ ")
                  ]),
                  _vm._v(" "),
                  _c("span", { staticClass: "modal__title--full" }, [
                    _vm._v(
                      "\n              " +
                        _vm._s(this.config.lang["modal.control.edit-header"]) +
                        "\n            "
                    )
                  ])
                ]),
                _vm._v(" "),
                _c("span", {
                  staticClass: "modal__close modal-close-action",
                  attrs: { id: "modal-close" },
                  on: { click: _vm.editJobClose }
                })
              ]
            ),
            _vm._v(" "),
            _c("li", { staticClass: "modal__content-item modal__control" }, [
              _c("p", { staticClass: "modal__control_header" }, [
                _vm._v(
                  "\n            " +
                    _vm._s(
                      this.config.lang["modal.control.printsettings-header"]
                    ) +
                    "\n          "
                )
              ]),
              _vm._v(" "),
              _c("div", { staticClass: "form__formrow" }, [
                _c("p", { staticClass: "form__row" }, [
                  _c(
                    "label",
                    {
                      staticClass: "modal__control_label",
                      attrs: { for: "edit-parameter-colortype" }
                    },
                    [
                      _vm._v(
                        "\n                " +
                          _vm._s(
                            this.config.lang[
                              "modal.control.printsettings-label-color"
                            ]
                          ) +
                          "\n              "
                      )
                    ]
                  ),
                  _vm._v(" "),
                  _c(
                    "select",
                    {
                      staticClass: "form__select--modalcontrol",
                      attrs: {
                        id: "edit-parameter-colortype",
                        name: "parameter-colortype"
                      }
                    },
                    _vm._l(
                      this.config.printparameter.single.colorType.select,
                      function(option) {
                        return _c(
                          "option",
                          {
                            attrs: { "data-image": option.image },
                            domProps: {
                              value: option.value,
                              selected: option.value === _vm.job.colorType
                            }
                          },
                          [
                            _vm._v(
                              "\n                  " +
                                _vm._s(option.text) +
                                "\n                "
                            )
                          ]
                        )
                      }
                    ),
                    0
                  )
                ]),
                _vm._v(" "),
                _c("p", { staticClass: "form__row" }, [
                  _c(
                    "label",
                    {
                      staticClass: "modal__control_label",
                      attrs: { for: "edit-parameter-printtype" }
                    },
                    [
                      _vm._v(
                        "\n                " +
                          _vm._s(
                            this.config.lang[
                              "modal.control.printsettings-label-print"
                            ]
                          ) +
                          "\n              "
                      )
                    ]
                  ),
                  _vm._v(" "),
                  _c(
                    "select",
                    {
                      staticClass: "js-ms-dropdown form__select--modalcontrol",
                      attrs: {
                        id: "edit-parameter-printtype",
                        name: "parameter-printtype"
                      }
                    },
                    _vm._l(
                      this.config.printparameter.single.printType.select,
                      function(option) {
                        return _c(
                          "option",
                          {
                            attrs: { "data-image": option.image },
                            domProps: {
                              value: option.value,
                              selected: option.value === _vm.job.printType
                            }
                          },
                          [
                            _vm._v(
                              "\n                  " +
                                _vm._s(option.text) +
                                "\n                "
                            )
                          ]
                        )
                      }
                    ),
                    0
                  )
                ])
              ]),
              _vm._v(" "),
              _c("p", { staticClass: "modal__control_header" }, [
                _vm._v(
                  "\n            " +
                    _vm._s(
                      this.config.lang["modal.control.papersettings-header"]
                    ) +
                    "\n          "
                )
              ]),
              _vm._v(" "),
              _c("div", { staticClass: "form__formrow" }, [
                _c("p", { staticClass: "form__row" }, [
                  _c(
                    "label",
                    {
                      staticClass: "modal__control_label",
                      attrs: { for: "edit-parameter-papertype" }
                    },
                    [
                      _vm._v(
                        "\n                " +
                          _vm._s(
                            this.config.lang[
                              "modal.control.printsettings-label-papertype"
                            ]
                          ) +
                          "\n              "
                      )
                    ]
                  ),
                  _vm._v(" "),
                  _c(
                    "select",
                    {
                      staticClass: "js-ms-dropdown form__select--modalcontrol",
                      attrs: {
                        id: "edit-parameter-papertype",
                        name: "parameter-papertype"
                      }
                    },
                    _vm._l(
                      this.config.printparameter.single.paperType.select,
                      function(option) {
                        return _c(
                          "option",
                          {
                            domProps: {
                              value: option.value,
                              selected: option.value === _vm.job.paperType
                            }
                          },
                          [
                            _vm._v(
                              "\n                  " +
                                _vm._s(option.text) +
                                "\n                "
                            )
                          ]
                        )
                      }
                    ),
                    0
                  )
                ]),
                _vm._v(" "),
                _c(
                  "div",
                  { staticClass: "form__formrow form__formrow--left" },
                  [
                    _c("p", { staticClass: "modal__control_label" }, [
                      _c("span", {
                        domProps: {
                          innerHTML: _vm._s(
                            this.config.lang["modal.control.sendc4-header"]
                          )
                        }
                      })
                    ]),
                    _vm._v(" "),
                    _c(
                      "label",
                      {
                        staticClass:
                          "form__pincheckbox form__pincheckbox--pointer form__pincheckbox--oneline",
                        attrs: { for: "parameter-c4letter" }
                      },
                      [
                        _c("input", {
                          directives: [
                            {
                              name: "model",
                              rawName: "v-model",
                              value: _vm.c4letter,
                              expression: "c4letter"
                            }
                          ],
                          staticClass: "form__pincheckbox-input",
                          attrs: {
                            type: "checkbox",
                            id: "parameter-c4letter",
                            name: "parameter-c4letter",
                            value: "1"
                          },
                          domProps: {
                            checked: Array.isArray(_vm.c4letter)
                              ? _vm._i(_vm.c4letter, "1") > -1
                              : _vm.c4letter
                          },
                          on: {
                            change: function($event) {
                              var $$a = _vm.c4letter,
                                $$el = $event.target,
                                $$c = $$el.checked ? true : false
                              if (Array.isArray($$a)) {
                                var $$v = "1",
                                  $$i = _vm._i($$a, $$v)
                                if ($$el.checked) {
                                  $$i < 0 && (_vm.c4letter = $$a.concat([$$v]))
                                } else {
                                  $$i > -1 &&
                                    (_vm.c4letter = $$a
                                      .slice(0, $$i)
                                      .concat($$a.slice($$i + 1)))
                                }
                              } else {
                                _vm.c4letter = $$c
                              }
                            }
                          }
                        }),
                        _vm._v(" "),
                        _c("span", { staticClass: "form__pincheckbox-border" }),
                        _vm._v(" "),
                        _c("span", {
                          staticClass:
                            "form__pincheckbox-label form__pincheckbox-label--colorblue",
                          domProps: {
                            innerHTML: _vm._s(
                              this.config.lang[
                                "modal.control.sendc4-description"
                              ]
                            )
                          }
                        })
                      ]
                    )
                  ]
                )
              ]),
              _vm._v(" "),
              _c(
                "div",
                {
                  directives: [
                    {
                      name: "show",
                      rawName: "v-show",
                      value: this.jobTypeId === "bulk",
                      expression: "this.jobTypeId === 'bulk'"
                    }
                  ],
                  staticClass: "form__formrow"
                },
                [
                  _c(
                    "p",
                    {
                      class: {
                        " form__row": true
                      }
                    },
                    [
                      _c(
                        "span",
                        { staticClass: "modal__control_label text--left" },
                        [
                          _vm._v(
                            "\n                " +
                              _vm._s(
                                this.config.lang[
                                  "modal.control.return-envelope-header"
                                ]
                              ) +
                              "\n                "
                          ),
                          _c("img", {
                            staticClass:
                              "ebrief-tooltip tipso_style upload__section_header_tooltip",
                            staticStyle: {
                              left: "7px",
                              position: "relative",
                              top: "3px",
                              height: "16px"
                            },
                            attrs: {
                              src: "/build/images/info-circle-darkgrey.svg",
                              "data-tipso-key": "return-envelope",
                              "data-tipso-moveleft": "2",
                              "data-tipso-movetop": "1",
                              alt: "Info"
                            }
                          })
                        ]
                      ),
                      _vm._v(" "),
                      _c(
                        "label",
                        {
                          staticClass:
                            "form__pincheckbox form__pincheckbox--pointer form__pincheckbox--oneline",
                          class: {
                            " --disabled":
                              _vm.job.recipients < 500 &&
                              !_vm.returnEnvelopeCheck
                          },
                          attrs: { for: "bulk-parameter-return-envelope-edit" }
                        },
                        [
                          _c("input", {
                            directives: [
                              {
                                name: "model",
                                rawName: "v-model",
                                value: _vm.returnEnvelopeCheck,
                                expression: "returnEnvelopeCheck"
                              }
                            ],
                            staticClass: "form__pincheckbox-input",
                            attrs: {
                              disabled:
                                _vm.job.recipients < 500 &&
                                !_vm.returnEnvelopeCheck,
                              type: "checkbox",
                              id: "bulk-parameter-return-envelope-edit",
                              name: "bulk-parameter-return-envelope-edit"
                            },
                            domProps: {
                              checked: Array.isArray(_vm.returnEnvelopeCheck)
                                ? _vm._i(_vm.returnEnvelopeCheck, null) > -1
                                : _vm.returnEnvelopeCheck
                            },
                            on: {
                              change: function($event) {
                                var $$a = _vm.returnEnvelopeCheck,
                                  $$el = $event.target,
                                  $$c = $$el.checked ? true : false
                                if (Array.isArray($$a)) {
                                  var $$v = null,
                                    $$i = _vm._i($$a, $$v)
                                  if ($$el.checked) {
                                    $$i < 0 &&
                                      (_vm.returnEnvelopeCheck = $$a.concat([
                                        $$v
                                      ]))
                                  } else {
                                    $$i > -1 &&
                                      (_vm.returnEnvelopeCheck = $$a
                                        .slice(0, $$i)
                                        .concat($$a.slice($$i + 1)))
                                  }
                                } else {
                                  _vm.returnEnvelopeCheck = $$c
                                }
                              }
                            }
                          }),
                          _vm._v(" "),
                          _c("span", {
                            staticClass: "form__pincheckbox-border"
                          }),
                          _vm._v(" "),
                          _c(
                            "span",
                            {
                              staticClass:
                                "form__pincheckbox-label form__pincheckbox-label--colorblue"
                            },
                            [
                              _c(
                                "span",
                                { staticClass: "text--content-bold" },
                                [
                                  _vm._v(
                                    "\n                    " +
                                      _vm._s(
                                        this.config.lang[
                                          "modal.control.return-envelope-checkbox-pt1"
                                        ]
                                      ) +
                                      "\n                    "
                                  ),
                                  _vm.returnEnvelopeCheck ? _c("br") : _vm._e(),
                                  _vm._v(" "),
                                  _c("span", {
                                    domProps: {
                                      innerHTML: _vm._s(
                                        this.config.lang[
                                          "modal.control.return-envelope-checkbox-pt2"
                                        ]
                                      )
                                    }
                                  })
                                ]
                              )
                            ]
                          )
                        ]
                      ),
                      _vm._v(" "),
                      _vm.returnEnvelopeCheck
                        ? _c(
                            "label",
                            {
                              staticClass:
                                "modal__control_label--return-envelope",
                              attrs: { for: "edit-parameter-envelopetype-1" }
                            },
                            [
                              _vm._v(
                                "\n                " +
                                  _vm._s(
                                    this.config.lang[
                                      "modal.control.return-envelope-franking-header"
                                    ]
                                  ) +
                                  "\n              "
                              )
                            ]
                          )
                        : _vm._e(),
                      _vm._v(" "),
                      _c(
                        "select",
                        {
                          staticClass:
                            "js-ms-dropdown form__select--modalcontrol form__hide",
                          attrs: {
                            id: "edit-parameter-envelopetype-1",
                            name: "parameter-papertype"
                          }
                        },
                        _vm._l(
                          this.config.printparameter.bulk.envelopeType.select,
                          function(option) {
                            return _c(
                              "option",
                              {
                                domProps: {
                                  value: option.value,
                                  selected:
                                    option.value === _vm.job.envelopeType
                                }
                              },
                              [
                                _vm._v(
                                  "\n                  " +
                                    _vm._s(option.text) +
                                    "\n                "
                                )
                              ]
                            )
                          }
                        ),
                        0
                      )
                    ]
                  ),
                  _vm._v(" "),
                  _vm.returnEnvelopeCheck
                    ? _c("p", { staticClass: "form__row --right" }, [
                        _c(
                          "label",
                          {
                            staticClass:
                              "modal__control_label--return-envelope",
                            attrs: { for: "bulk-parameter-return-address-edit" }
                          },
                          [
                            _vm._v(
                              "\n                " +
                                _vm._s(
                                  this.config.lang[
                                    "modal.control.return-envelope-textarea-header"
                                  ]
                                ) +
                                "\n              "
                            )
                          ]
                        ),
                        _vm._v(" "),
                        _c("textarea", {
                          directives: [
                            {
                              name: "model",
                              rawName: "v-model",
                              value: _vm.returnAddress,
                              expression: "returnAddress"
                            }
                          ],
                          staticClass: "dd form__field--textarea-address ",
                          attrs: {
                            id: "bulk-parameter-return-address-edit",
                            name: "parameter-return-address",
                            maxlength: "200",
                            placeholder: this.config.lang[
                              "modal.control.return-envelope-textarea-placeholder"
                            ],
                            rows: "3"
                          },
                          domProps: { value: _vm.returnAddress },
                          on: {
                            input: function($event) {
                              if ($event.target.composing) {
                                return
                              }
                              _vm.returnAddress = $event.target.value
                            }
                          }
                        }),
                        _vm._v(" "),
                        _c(
                          "span",
                          {
                            staticClass: "modal__control_label--char-count",
                            class: {
                              " --warning": _vm.addressCharLeft <= 10
                            }
                          },
                          [
                            _vm._v(
                              "\n                noch " +
                                _vm._s(_vm.addressCharLeft) +
                                " Zeichen\n              "
                            )
                          ]
                        )
                      ])
                    : _vm._e()
                ]
              ),
              _vm._v(" "),
              _c("p", {
                staticClass: "modal__control_header",
                domProps: {
                  innerHTML: _vm._s(
                    this.config.lang["modal.control.registeredletter-header"]
                  )
                }
              }),
              _vm._v(" "),
              _c("div", { staticClass: "form__formrow form__formrow--left" }, [
                _c(
                  "label",
                  {
                    staticClass: "form__pincheckbox form__pincheckbox--pointer",
                    attrs: { for: "parameter-registeredletter" }
                  },
                  [
                    _c("input", {
                      directives: [
                        {
                          name: "model",
                          rawName: "v-model",
                          value: _vm.registeredLetter,
                          expression: "registeredLetter"
                        }
                      ],
                      staticClass: "form__pincheckbox-input",
                      attrs: {
                        type: "checkbox",
                        id: "parameter-registeredletter",
                        name: "parameter-registeredletter",
                        value: "1"
                      },
                      domProps: {
                        checked: Array.isArray(_vm.registeredLetter)
                          ? _vm._i(_vm.registeredLetter, "1") > -1
                          : _vm.registeredLetter
                      },
                      on: {
                        change: function($event) {
                          var $$a = _vm.registeredLetter,
                            $$el = $event.target,
                            $$c = $$el.checked ? true : false
                          if (Array.isArray($$a)) {
                            var $$v = "1",
                              $$i = _vm._i($$a, $$v)
                            if ($$el.checked) {
                              $$i < 0 &&
                                (_vm.registeredLetter = $$a.concat([$$v]))
                            } else {
                              $$i > -1 &&
                                (_vm.registeredLetter = $$a
                                  .slice(0, $$i)
                                  .concat($$a.slice($$i + 1)))
                            }
                          } else {
                            _vm.registeredLetter = $$c
                          }
                        }
                      }
                    }),
                    _vm._v(" "),
                    _c("span", { staticClass: "form__pincheckbox-border" }),
                    _vm._v(" "),
                    this.config.userIsCompany
                      ? _c("span", {
                          staticClass:
                            "form__pincheckbox-label form__pincheckbox-label--colorblue",
                          domProps: {
                            innerHTML: _vm._s(
                              this.config.lang[
                                "modal.control.registeredletter-label-business"
                              ]
                            )
                          }
                        })
                      : _vm._e(),
                    _vm._v(" "),
                    !this.config.userIsCompany
                      ? _c("span", {
                          staticClass:
                            "form__pincheckbox-label form__pincheckbox-label--colorblue",
                          domProps: {
                            innerHTML: _vm._s(
                              this.config.lang[
                                "modal.control.registeredletter-label-privat"
                              ]
                            )
                          }
                        })
                      : _vm._e()
                  ]
                )
              ]),
              _vm._v(" "),
              _c("div", { staticClass: "modal__control_action" }, [
                _vm.validationError && _vm.returnEnvelopeCheck
                  ? _c("div", { staticClass: "form__validation_error" }, [
                      _c(
                        "p",
                        {
                          staticClass: "form__errors",
                          attrs: { id: "errorOutput" }
                        },
                        [
                          _vm._v(
                            "\n                " +
                              _vm._s(_vm.validationError) +
                              "\n              "
                          )
                        ]
                      )
                    ])
                  : _vm._e(),
                _vm._v(" "),
                _c(
                  "div",
                  { staticClass: "modal__control_actionwrapper form__formrow" },
                  [
                    _c("p", { staticClass: "form__row" }, [
                      _c(
                        "button",
                        {
                          staticClass:
                            "form__button form__button--green modal__control_submit",
                          on: { click: _vm.editJobEdit }
                        },
                        [
                          _vm._v(
                            "\n                  " +
                              _vm._s(
                                this.config.lang["modal.control.edit-submit"]
                              ) +
                              "\n                "
                          )
                        ]
                      )
                    ]),
                    _vm._v(" "),
                    _c("p", { staticClass: "form__row" }, [
                      _c(
                        "button",
                        {
                          staticClass:
                            "modal__control_cancel modal-close-action modal__error-button modal__delete_action delete__from--success",
                          on: { click: _vm.editJobDelete }
                        },
                        [
                          _c("i", { staticClass: "icofont-trash" }),
                          _vm._v(
                            "\n                  " +
                              _vm._s(
                                this.config.lang["modal.control.preview-delete"]
                              ) +
                              "\n                "
                          )
                        ]
                      )
                    ])
                  ]
                ),
                _vm._v(" "),
                _c("p", { staticClass: "modal__control_actionwrapper" }, [
                  _c(
                    "a",
                    {
                      staticClass: "modal__control_cancel modal-close-action",
                      attrs: {
                        href: "javascript:void(0);",
                        id: "#modal-close-single"
                      },
                      on: { click: _vm.editJobClose }
                    },
                    [
                      _vm._v(
                        "\n                " +
                          _vm._s(
                            this.config.lang["modal.control.action-cancel"]
                          ) +
                          "\n              "
                      )
                    ]
                  )
                ])
              ])
            ])
          ]
        )
      ])
    ])
  ])
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }